export const PLAN_TYPES = {
  FREE: {
    value: 1,
    label: 'Free'
  },
  PREMIUM: {
    value: 2,
    label: 'Premium'
  }
};
